import {
  CampaignConfigDto,
  DiscountDto,
  PopulatedCampaignUserDtoStatusEnum,
  RewardConfigDtoTypeEnum,
} from '@coretava/api/ecommerce-service';
import React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@mui/material';
import { Tabs } from '@gamiphy/loyalty-station-desktop/store/ui';
import CampaignHeader from './CampaignHeader';
import Tab from '../cashbackProgram/loggedIn/components/Tab';
import CampaignContent from './CampaignContent';

type Props = {
  campaign: CampaignConfigDto,
  status: PopulatedCampaignUserDtoStatusEnum,
  discount?: DiscountDto,
  textAlign?: 'center' | 'left'
}

const Campaign: React.FC<Props> = ({
  campaign,
  discount,
  status,
  textAlign,
}) => {
  const isCollapsible = React.useMemo(() => campaign.rewardConfig?.type !== RewardConfigDtoTypeEnum.Bogo, [campaign]);

  return (
    isCollapsible ? (
      <Tab
        header={<CampaignHeader campaign={campaign} discount={discount} />}
        tab={Tabs.Campaign}
        id={campaign.id}
      >
        <CampaignContent campaign={campaign} discount={discount} status={status} />
      </Tab>
    ) : (
      <Card sx={{ p: 2 }}>
        <CampaignContent campaign={campaign} discount={discount} textAlign={textAlign} status={status} />
      </Card>
    )
  );
};

export default observer(Campaign);
